/**
 * HR Leave History Export page — /hr/leave-history-export
 *
 * Downloads leave records as a CSV in the same layout the import reads, so HR
 * can load them back into the legacy HRIS (or re-import here unchanged). The
 * whole surface is the export card; it lives beside "Import leave history".
 */

import { PageHead } from '../components/primitives/PageHead'
import { HrAccessGuard } from '../components/hr/HrAccessGuard'
import { LeaveHistoryExportCard } from './hr-leave-history/LeaveHistoryExportCard'

export function HrLeaveHistoryExportPage(): JSX.Element {
  return (
    <HrAccessGuard>
      <PageHead
        eyebrow="HR"
        title="Export leave history"
        subtitle="Download leave records as a CSV in the same layout the import reads, so you can load them back into the old system or re-import here unchanged."
      />
      <LeaveHistoryExportCard />
    </HrAccessGuard>
  )
}
